import { Cookies } from 'react-cookie'

import { reducer as notifyReducer } from 'tools/Notify/reducer'
import { defaultState as defaultNotify } from 'tools/Notify/reducer'
import apollo from 'utils/apollo'
import { freeze } from 'utils/dom'

import { authRequest, signonDropStates, signonInitialState } from 'app/Auth/lib'
import { signonReducer } from 'app/Auth/reducer'
import { defaultUser, normalizeUser } from 'libreon/User/lib'

export const cookies = new Cookies()
export const COOKIE_NAME = 'e'
// const starting = cookies.get(COOKIE_NAME) || {}

////////////////////////////////////////////////////////////////////////////////
export function generateBaseGlobalState(seed) {
  return freeze({
    notify: defaultNotify,
    ...seed,
    apolloInit: false,
    apollo: apollo(() => {}),
    page: freeze({}),
    // global tab state we can update for challenge blinkers and such
    tabs: freeze({}),
    theme: 'dark',
    user: defaultUser(),
    signon: signonInitialState()
  })
}

// export const defaultBaseGlobalState = generateBaseGlobalState({})

export function resetBaseGlobalState(oldState, newSeed) {
  oldState.apollo.cache.reset()
  signonDropStates()
  authRequest('signout', {})

  // keep notify messages across state transitions
  return generateBaseGlobalState({
    notify: oldState.notify,
    nav: oldState.nav,
    ...newSeed
  })
}

export const BASE_R_GLOBAL = {
  APOLLO_RESET: Symbol('APOLLO_RESET'),
  NOTIFY: Symbol('NOTIFY'),
  USER_SET: Symbol('USER_SET'),
  USER_MERGE: Symbol('USER_MERGE'),
  PAGE_MERGE: Symbol('PAGE_MERGE'),
  PAGE_SET: Symbol('PAGE_SET'),
  PAGE_NAV_STATE: Symbol('PAGE_NAV_STATE'),
  PAGE_NAV_SPEC: Symbol('PAGE_NAV_SPEC'),
  PAGE_THEME: Symbol('PAGE_THEME'),
  PAGE_TITLE: Symbol('PAGE_TITLE'),
  PAGE_MENU: Symbol('PAGE_MENU'),
  // TODO: Retire
  PREFS_SET: Symbol('PREFS_SET'),
  PREFS_READY: Symbol('PREFS_READY'),
  PREFS_SHOW_COLS: Symbol('PREFS_SHOW_COLS'),
  PREFS_FILTER_COLS: Symbol('PREFS_FILTER_COLS')
}

export function baseGlobalReducer(state, { type, ...action }) {
  if (type === undefined) {
    console.log(`baseGlobalReducer undefined type ${action}`)
    throw new Error(`baseGlobalReducer - undefined dispatch type`)
  }
  switch (type) {
    case BASE_R_GLOBAL.APOLLO_RESET:
      return { ...state, apolloInit: true, apollo: apollo(action.dispatch) }

    case BASE_R_GLOBAL.NOTIFY:
      return { ...state, notify: notifyReducer(state.notify, action.value) }

    //////////////////////////////
    case BASE_R_GLOBAL.USER_SET: {
      const user = normalizeUser(action.value, true)
      return { ...state, user }
    }

    case BASE_R_GLOBAL.USER_MERGE:
      return { ...state, user: { ...state.user, ...action.value } }

    // NEW KEEP
    case BASE_R_GLOBAL.PAGE_MERGE: {
      return { ...state, page: { ...state.page, ...action.value } }
    }

    case BASE_R_GLOBAL.PAGE_SET: {
      return {
        ...state,
        page: {
          ...state.page,
          routeId: undefined,
          navId: undefined,
          ...action.value
        }
      }
    }

    //////////////////////////////
    // this is a reset
    case BASE_R_GLOBAL.PAGE_NAV_STATE:
      return {
        ...state,
        nav: Object.freeze({ ...state.nav, ...action.value.nav })
      }

    case BASE_R_GLOBAL.PAGE_NAV_SPEC: {
      const { spec } = action
      return {
        ...state,
        nav: Object.freeze({ itemId: undefined, current: undefined, spec })
      }
    }

    case BASE_R_GLOBAL.PAGE_THEME:
      return Object.freeze({ ...state, pageTheme: action.value })

    case BASE_R_GLOBAL.PAGE_TITLE:
      return Object.freeze({ ...state, title: action.title })

    // todo: revise the state updates of this using Navigator, to separate
    // specs from runtime states
    case BASE_R_GLOBAL.PAGE_MENU: {
      const { userMenu, siteMenu } = action
      return Object.freeze({ ...state, menus: { userMenu, siteMenu } })
    }

    // case R_GLOBAL.TAGS_SET:
    //   return {
    //     ...state,
    //     user: {
    //       ...state.user,
    //       profile: action.value,
    //       ...normalizeUserParam('profile', action.value)
    //     }
    //   }
    //
    case BASE_R_GLOBAL.PREFS_SET: {
      const prefs = {
        ...state.prefs,
        [action.key]: { ...state.prefs[action.key], ...action.value }
      }
      // cookies.set(COOKIE_NAME, prefs, { path: '/' })
      return { ...state, prefs: { ...prefs, skip: true } }
    }

    case BASE_R_GLOBAL.PREFS_READY:
      return { ...state, prefs: { ...state.prefs, skip: false } }

    case BASE_R_GLOBAL.PREFS_SHOW_COLS: {
      let prefs = state.prefs || {}
      const show = prefs.show || {}
      const { key, ...rest } = action
      show[key] = { ...rest }
      prefs = { ...prefs, show: { ...show } }
      cookies.set(COOKIE_NAME, prefs, { path: '/' })
      return { ...state, prefs: { ...prefs } }
    }

    case BASE_R_GLOBAL.PREFS_FILTER_COLS: {
      let filters = state.prefs.filters || {}
      const { key, reset, merge, set } = action
      if (reset) {
        filters = {}
      } else if (merge) {
        filters[key] = { ...(filters[key] || {}), ...merge }
      } else if (set) {
        filters[key] = set
      }
      const prefs = { ...state.prefs, filters: { ...filters } }
      cookies.set(COOKIE_NAME, prefs, { path: '/' })
      return { ...state, prefs: { ...prefs } }
    }

    // case R_GLOBAL.NAV_CHALLENGE: {
    //   let { menu, bar, value } = action
    //   if (menu) {
    //     menu = navChallenge(state.nav.menu, menu, value)
    //     return { ...state, nav: { ...state.nav, menu } }
    //   }
    //   bar = navChallenge(state.nav.bar, bar, value)
    //   return { ...state, nav: { ...state.nav, bar } }
    // }
    //
    // case R_GLOBAL.MERGE_EDITABLE:
    //   return { ...state, ...action }

    default:
      return signonReducer(state, type, action)
  }
}

// function navChallenge(list, key, value) {
//   return list.map((item) => {
//     if (item.label === key) {
//       return { ...item, challenge: value }
//     }
//     return item
//   })
// }
